const content = `<b style="font-size: 2.2rem;">Datenschutzerklärung zur Registrierung</b>

Wir freuen uns, dass Sie sich bei manny+nanny | DIE BABYSITTER AGENTUR, einem Geschäftsbereich der Lenssen GmbH, registrieren möchten. Im Rahmen Ihrer Registrierung verarbeiten wir Ihre personenbezogenen Daten, um Ihnen als interessierter Nutzerin, Familie oder potenzieller Jobsuchender ein Benutzerkonto zu erstellen. Hierzu ist es erforderlich, dass Sie unseren verlinkten Allgemeinen Geschäftsbedingungen (AGB) und unserer verlinkten Datenschutzerklärung zustimmen.

Darüber hinaus können Sie sich optional für unseren Newsletter anmelden. In diesem Fall erhalten Sie maximal einmal im Monat wertvolle Tipps, spannende Einblicke und exklusive Inhalte rund um die Kinderbetreuung. Sowohl Ihre Zustimmung zur Registrierung als auch zum Erhalt des Newsletters können Sie jederzeit mit Wirkung für die Zukunft widerrufen.

Ausführliche Informationen zur Datenverarbeitung und zu Ihren Rechten gemäß DSGVO finden Sie in unserer vollständigen Datenschutzerklärung.
`

function PrivacyPolicyRegisterDe(props) {
    return (
        <div className="text_2_black" style={{whiteSpace: "pre-wrap"}} dangerouslySetInnerHTML={{__html: content}}/>
    );
}

export default PrivacyPolicyRegisterDe;
